const state = () => {
  return {
    sc_work_groups: [],
    sc_work_group: {},
    sc_work_group_filters: {},
  }
}

export default state;
